const SET_CHECKOUT_PROMO_ERROR = 'classpass/checkout/SET_CHECKOUT_PROMO_ERROR';
const CLEAR_CHECKOUT_PROMO_ERROR = 'classpass/checkout/CLEAR_CHECKOUT_PROMO_ERROR';

const initialState = {
  checkoutPromoError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CHECKOUT_PROMO_ERROR:
      return { ...state, checkoutPromoError: action.data };
    case CLEAR_CHECKOUT_PROMO_ERROR:
      return { ...state, checkoutPromoError: null };
    default:
      return state;
  }
}

export const setCheckoutPromoError = error => ({ type: SET_CHECKOUT_PROMO_ERROR, data: error });
export const clearCheckoutPromoError = () => ({ type: CLEAR_CHECKOUT_PROMO_ERROR });
